import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/warehouse/importer/warehouseImporterActions';

export default importerReducers(actions);
